import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { useLang, useL } from "@/i18n";
import { api } from "@/lib/api";

export default function ServiceDetail() {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const L = useL();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/services/${slug}`).then((r) => setS(r.data)).catch(() => setS(false)); }, [slug]);

  if (s === null) return <div className="grid min-h-[50vh] place-items-center text-navy">{t("common.loading")}</div>;
  if (s === false) return <div className="grid min-h-[50vh] place-items-center text-navy">{t("common.notFound")} <Link to="/services" className="ml-2 text-sunset underline">{t("nav.services")}</Link></div>;
  const Icon = Icons[s.icon] || Icons.Sparkles;

  return (
    <div data-testid="service-detail-page">
      <section className="bg-navy py-16">
        <div className="mx-auto max-w-3xl px-4 text-center">
          <div className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-2xl bg-gold/15 text-gold"><Icon size={30} /></div>
          <h1 className="font-display text-4xl font-bold text-cream">{L(s, "title")}</h1>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-4 py-14">
        <p className="text-lg leading-relaxed text-navy/80">{L(s, "body") || L(s, "short")}</p>
        <div className="mt-10 rounded-2xl bg-cream-card p-8 text-center card-shadow">
          <p className="font-head text-lg font-semibold text-navy">{lang === "fr" ? "Intéressé par ce service ?" : "Interested in this service?"}</p>
          <Link to="/contact" className="btn-gold mt-4 inline-block rounded-full px-7 py-3 text-sm font-bold">{lang === "fr" ? "Nous contacter" : "Contact Us"}</Link>
        </div>
      </section>
    </div>
  );
}
